import { TrackingEvent } from '../../../sdk/tracking.event';
import { DeeplinkEvent } from '../../../sdk/deeplink.event';
import style from './NotificationCenterListing.css';
import NotificationCenterListItem from '../NotificationCenterListItem/NotificationCenterListItem';

export default function NotificationCenterListing({ notifications = [] }) {
  function onNotificationItemClick(notification) {
    TrackingEvent.trigger(
      TrackingEvent.Events.DISCOVER_TAP_ACTION,
      TrackingEvent.Sources.CAAS,
      { source: 'notification_center' },
    );

    if (notification.deeplink !== undefined) {
      DeeplinkEvent.open(notification.deeplink);
    }
  }

  return (
    <div className={style.container}>
      <div className={style['notifications-list']}>
        {notifications.map(notification => (
          <NotificationCenterListItem
            key={notification.id}
            className={style.item}
            notification={notification}
            onClick={() => onNotificationItemClick(notification)}
          />
        ))}
      </div>
    </div>
  );
}
